import { useState } from 'react';
import Logo from '../assets/images/logo.png';
import {AiOutlineSearch} from 'react-icons/ai';
import { HiMenuAlt1 } from "react-icons/hi";
import { VscClose } from "react-icons/vsc";

const HeaderComponent = () => {

    const [ showSlide, setshowSlide ] = useState(false)

    return (

        <header className="header" >

            <div className='header_left' >
                <a href='#s' className='header_left_a' >
                    <img src={Logo} alt='' />
                </a>
                <a href='#learn_more' className='header_left_a' >Phones</a>
                <a href='#learn_more' className='header_left_a' >Smart Watches</a>
                <a href='#learn_more' className='header_left_a' >Accesories</a>
            </div>

            <div className='header_right' >
                <a href='#s' className='header_right_a' >Where to Buy</a>
                <a href='#s' className='header_right_a' >Support</a>
                <a href='#s' className='header_right_a' >
                    <AiOutlineSearch className='header_right_a_ic' />
                </a>
                <HiMenuAlt1 className='header_right_burger' onClick={ () => setshowSlide(true) } />
            </div>

           { showSlide ? 
           
           <>
           
            <div className='header_backdrop' onClick={ () => setshowSlide(false) } >

            </div>

            <div className='header_backdrop_2' >

                <div className='header' style={{
                    padding:'1rem',
                    backgroundColor:"#1F0235"
                }} >
                    
                    <div className='header_left' >
                    <a href='#s' className='header_left_a' >
                        <img src={Logo} alt='' />
                    </a>
                </div>

                <div className='header_right'  >
                    <VscClose className='header_right_burger' onClick={ () => setshowSlide(false) } />
                </div>

                </div>

                <a href='#preorder' onClick={ () => setshowSlide(false) } className='header_backdrop_2_a' >
                    Phones
                </a>
                <a href='#preorder' onClick={ () => setshowSlide(false) } className='header_backdrop_2_a' >
                    Smart Watches
                </a>
                <a href='#preorder' onClick={ () => setshowSlide(false) } className='header_backdrop_2_a' >
                    Accesories
                </a>
                <a href='#preorder' onClick={ () => setshowSlide(false) } className='header_backdrop_2_a' >
                    Support
                </a>

                <a href='#preorder' onClick={ () => setshowSlide(false) } className='header_backdrop_2_a' >
                    Where to buy
                </a>

            </div>
           
           </>
           
           
           : <></>  }
            

        </header>

    );

}

export default HeaderComponent;